//* Importing Icons
import { BsFileEarmarkSpreadsheet, BsFillEyeFill, BsGraphUp } from "react-icons/bs";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { TfiCheck } from "react-icons/tfi";
import { RxSwitch } from "react-icons/rx";
import { FaRegHeart } from "react-icons/fa";

export function Actions(props: {
  actionItem: { id: any };
  onDeleteClick?: () => void;
  onEditClick?: () => void;
  onManagerClick?: () => void;
  onAuxiliar1Click?: () => void;
  onPermissionClick?: () => void;
  onCorrectionClick?: () => void;
  onLifecycleClick?: () => void;
  onSaveToListClick?: () => void;
  hideManager?: boolean;
  hideEdit?: boolean;
  hideDelete?: boolean;
  showAuxiliar1?: boolean;
  showPermissions?: boolean;
  showCorrection?: boolean;
  showLifecycle?: boolean;
  showSaveToList?: boolean;
}) {
  return (
    <div className="d-flex align-items-center justify-content-center">
      {props.showSaveToList && (
        <span
          onClick={() => {
            if (props.onSaveToListClick) props.onSaveToListClick();
          }}
          className="icon p-1"
          style={{ cursor: "pointer" }}
          title="Salvar em lista"
        >
          <FaRegHeart size={22} color="#e0245e" />
        </span>
      )}

      {props.showPermissions && (
        <span
          onClick={() => {
            if (props.onPermissionClick) props.onPermissionClick();
          }}
          className="icon p-1"
          style={{ cursor: "pointer" }}
          title="Permissões"
        >
          <RxSwitch size={24} color="#007bff" />
        </span>
      )}

      {props.showCorrection && (
        <span
          onClick={() => {
            if (props.onCorrectionClick) props.onCorrectionClick();
          }}
          className="icon p-1"
          style={{ cursor: "pointer" }}
          title="Corrigir"
        >
          <TfiCheck size={24} color="#17a2b8" />
        </span>
      )}

      {props.showAuxiliar1 && (
        <span
          onClick={() => {
            if (props.onAuxiliar1Click) props.onAuxiliar1Click();
          }}
          className="icon p-1"
          style={{ cursor: "pointer" }}
          title="Baixar Arquivo .csv"
        >
          <BsFileEarmarkSpreadsheet size={24} color="#28a745" />
        </span>
      )}
      {props.showLifecycle && (
        <span
          onClick={() => {
            if (props.onLifecycleClick) props.onLifecycleClick();
          }}
          className="icon p-1"
          style={{ cursor: "pointer" }}
          title="Ciclo de vida"
        >
          <BsGraphUp size={24} color="#6610f2" />
        </span>
      )}
      {!props.hideManager && (
        <span
          onClick={() => {
            if (props.onManagerClick) props.onManagerClick();
          }}
          className="icon p-1"
          style={{ cursor: "pointer" }}
          title="Gerenciar"
        >
          <BsFillEyeFill size={24} color="#ffc107" />
        </span>
      )}
      {!props.hideEdit && (
        <span
          onClick={() => {
            if (props.onEditClick) props.onEditClick();
          }}
          className="icon p-1"
          style={{ cursor: "pointer" }}
          title="Editar"
        >
          <MdModeEdit size={24} color="#6c757d" />
        </span>
      )}
      {!props.hideDelete && (
        <span
          onClick={() => {
            if (props.onDeleteClick) props.onDeleteClick();
          }}
          className="icon p-1"
          style={{ cursor: "pointer" }}
          title="Deletar"
        >
          <MdDelete size={24} color="#dc3545" />
        </span>
      )}
    </div>
  );
}
